import {ChangeDetectionStrategy, Component, input, signal} from '@angular/core';
import {ModalsControlService} from '../../../../../../services/modals-control.service';
import {ModalCommand} from '../../../../../../types/ModalCommand';
import {ModalTypeEnum} from '../../../../../../enums/ModalEnums';
import {Content} from './update-info-content';

@Component({
  selector: 'app-cpru-update',
  templateUrl: './cpru-update.component.html',
  styleUrl: './cpru-update.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruUpdateComponent {
  public careProviderUnitId = input<number>(null);
  public isExpanded = signal<boolean>(false);
  public content = Content;

  constructor(private modalControl: ModalsControlService) {}

  public openModal(): void {
    const modalCommand: ModalCommand = {
      type: ModalTypeEnum.UPDATE_INFO,
      data: this.careProviderUnitId(),
    };
    this.modalControl.openModal(modalCommand);
  }

  public toggleExpand() {
    this.isExpanded.update((prev) => !prev);
  }
}
